module.exports = __webpack_public_path__ + "_assets/img/profile-11.c810043b.svg";